import React from 'react';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { MaritalStatuses } from '../../../../global/constants/lists';
import { getFormattedDate } from '../../../../global/helpers/date-helpers';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { Person } from '../../../../global/models/person-model';
import { AnnualEnrollmentProps } from '../../../arc/models/arc-epi-props';
import { Spouse } from '../../features/relationships/relationships-model';
import { getInitialMailingAddress, getInitialPersonInfo } from '../../helpers/form-init-helpers';
import { getMaritalStatusText } from '../../helpers/format-helpers';
import { MailingAddressDisplay } from './mailing-address-display';
import { PersonFieldsContentDisplay } from './person-fields-display';

interface Props {
	person: Person;
	spouse: Spouse;
	labelSetting: LabelSettingProps;
	annualEnrollmentProps: AnnualEnrollmentProps;
	editLink: JSX.Element;
}
export function MaritalStatusDisplay(props: Props) {
	const { person, spouse, labelSetting, annualEnrollmentProps, editLink } = props;

	const isMarried = person?.marital_status === MaritalStatuses.Married;

	return (
		<DividerSection sectionText={annualEnrollmentProps?.maritalStatusHeader} secondarySectionNode={editLink}>
			<LabelAndValue label={annualEnrollmentProps?.maritalStatusLabel} value={getMaritalStatusText(person?.marital_status, labelSetting)} />
			{
				isMarried && spouse?.start_date &&
				<LabelAndValue label={annualEnrollmentProps?.dateOfMarriageLabel} value={getFormattedDate(spouse.start_date)} />
			}
			{
				isMarried &&
				<>
					<ContentSpacer>
						<h3>{annualEnrollmentProps.spouseInformationHeader}</h3>
					</ContentSpacer>
					<PersonFieldsContentDisplay
						labelSetting={labelSetting}
						values={getInitialPersonInfo(spouse?.person)}
						dobMasked
					/>

					{
						spouse?.person?.mailing_address_1 &&
						<MailingAddressDisplay
							labelSetting={labelSetting}
							values={getInitialMailingAddress(spouse?.person)}
						/>
					}
				</>
			}
		</DividerSection>
	);
}
